module.exports = __webpack_public_path__ + "img/awards_money2.f800d11a.png";